var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row comp-useradmin-delete-or-anomize"},[_c('div',{staticClass:"col-12 cl-md-6"},[_c('sprbutton',{attrs:{"type":"primary","title":_vm.$t('adminUserEditor.removeUser'),"size":1,"click-event":"deleteOrAnomize"},on:{"deleteOrAnomize":_vm.initiateDeleteOrAnonymize}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }